import { IBarring } from "../interface/IBarrings";

export interface IBarringResponse {
    barringCode: string;
    name: string;
    addedByCollection: boolean;
    active: boolean;
}

export interface IBarringListResponse {
    barrings: IBarringResponse[];
}

export const getResponseToState = (response: IBarringListResponse): IBarring[] =>
    response.barrings.map((barring) => ({
        addedByCollection: barring.addedByCollection,
        name: barring.name,
        barringCode: barring.barringCode,
        isActive: barring.active,
    }));
